import { opts, additionalOptions } from '../config';
import {
	getPhoneAssignmentData,
	initQuadTransform,
	addSiteLabelToHeap,
	initPhoneAssignmentConfig
} from '../helpers';
// modForm for preload-calls js on leads+calls pages.
export const modForm = {
	getPhoneAssignmentData,
	initQuadTransform,
	initPhoneAssignmentConfig,
	...additionalOptions,
	...opts,
	init: function(options) {
		const phoneAssignmentCallOnlyDefaultConfig = {
			...modForm.opts.phoneAssignmentConfig,
			showPhoneAssignmentNumber: false,
			skipMatching: false,
			formatNumberWithBracketsAndDash: false,
			phoneNumberContainerSelector: '.call-tracking'
		};
		modForm.opts.phoneAssignmentConfig = phoneAssignmentCallOnlyDefaultConfig;
		modForm.opts.websiteName = window.location.host;
		modForm.opts.trafficDetailsApi = 'api/TrafficDetails/get';
		modForm.opts.quadLinkParams = {};
		modForm.opts.qsParams = modForm.opts.qsParams ? modForm.opts.qsParams : ['CCID', 'CLK', 'QTR'];
		modForm.opts.quadLinkHasBeenTransformed = false;
		modForm.opts.quadLinkData = {
			WebSiteName: modForm.opts.websiteName,
			quadlink: '',
			defaultQuad: '',
			tagID: ''
		};

		modForm.opts.landingPageNoQuery = modForm.opts.landingPage.split('?')[0];

		modForm.opts = { ...modForm.opts, ...options };

		if (options && options.phoneAssignmentConfig) {
			modForm.opts.phoneAssignmentConfig = {
				...phoneAssignmentCallOnlyDefaultConfig,
				...options.phoneAssignmentConfig
			};
		}

		document.addEventListener('heap.loaded', function() {
			addSiteLabelToHeap();
		});
	}
};
